/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/empty-section/plantlife-empty-section/plantlife-empty-section.component.scss */
/*# sourceMappingURL=plantlife-empty-section.component.css.map */
